module.exports = __webpack_public_path__ + "img/smart_nav.964b40c6.png";